/*
  Bolaméa, audit Accessibilité.
  A11Y-009 (WCAG 4.1.3) : annonce aux lecteurs d'écran
  - le nombre de produits après un filtre (collections, recherche),
  - la variante choisie et son prix après un changement de variante (fiche produit).
  Une seule région polie, invisible. S'appuie sur les événements d'Horizon (filter:update, variant:update),
  sans modifier ses fichiers.
  A11Y-004 : seul le bouton « Agrandir l'image » de la photo affichée reste dans l'ordre de tabulation
  (les autres photos du diaporama sont hors écran).
*/
const region = document.createElement('div');
region.className = 'visually-hidden';
region.setAttribute('role', 'status');
region.setAttribute('aria-live', 'polite');
document.body.append(region);

let minuteur;
const annoncer = (texte) => {
  if (!texte) return;
  clearTimeout(minuteur);
  region.textContent = '';
  minuteur = setTimeout(() => { region.textContent = texte; }, 120);
};

const visible = (el) => !!el && el.getClientRects().length > 0;
const texteDe = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');

/* Attend qu'une valeur change (rendu des sections par Horizon), puis l'annonce. Annonce la valeur courante après 5 s au plus. */
const attendreEtAnnoncer = (lire, avant, mettreEnForme) => {
  const debut = Date.now();
  const tour = () => {
    const maintenant = lire();
    if ((maintenant && maintenant !== avant) || Date.now() - debut > 5000) return annoncer(mettreEnForme(maintenant));
    setTimeout(tour, 150);
  };
  setTimeout(tour, 150);
};

const compteProduits = () => texteDe([...document.querySelectorAll('[data-testid="products-count"]')].find(visible));
document.addEventListener('filter:update', () => {
  const avant = compteProduits();
  attendreEtAnnoncer(compteProduits, avant, (t) => t);
});

const prixFiche = () => {
  const prix = [...document.querySelectorAll('main product-price')].find(visible);
  return texteDe(prix?.querySelector('.price') || prix);
};
document.addEventListener('variant:update', (e) => {
  const avant = prixFiche();
  const choix = [...document.querySelectorAll('main variant-picker input:checked')].map((i) => i.value).join(', ');
  const debut = Date.now();
  const tour = () => {
    const p = prixFiche();
    if ((p && p !== avant) || Date.now() - debut > 1500) return annoncer([choix, p].filter(Boolean).join(', '));
    setTimeout(tour, 150);
  };
  setTimeout(tour, 150);
});

document.addEventListener('slideshow:select', (e) => {
  if (!(e.target instanceof Element) || !e.detail?.slide) return;
  const boutons = e.target.querySelectorAll('.bv-zoom-bouton');
  for (const bouton of boutons) bouton.tabIndex = bouton.closest('slideshow-slide') === e.detail.slide ? 0 : -1;
});
